import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { disableTrackEventsAtom } from '../Filter/filterStore';
import useRudderStackTrack from '../../../../hooks/useRudderStackTrack';

export const useBoatPositionPriceTrack = (filteredBoats, areBoatsLoading: boolean, routerReady: boolean) => {
  const [disableTrackEvents, setDisableTrackEvents] = useAtom(disableTrackEventsAtom);
  const rudderTrack = useRudderStackTrack();

  useEffect(() => {
    if (!routerReady || areBoatsLoading) return;

    if (disableTrackEvents) {
      setTimeout(() => {
        setDisableTrackEvents(false);
      }, 10);
      return;
    }

    const valuesToPush: any[] = [];

    Object.keys(filteredBoats).forEach((key, position) => {
      const item = filteredBoats[key];
      const perHour = item.display_price_per_hour;

      const object: any = {
        public_id: item.boat_public_id,
        position,
        price: `${perHour}/hour`,
      };

      if (item.is_top_owner) object.topOwner = true;
      if (item.new_boat) object.newBoat = true;

      valuesToPush.push(object);
    });

    if (valuesToPush.length !== 0) {
      rudderTrack('js_boat_position_price', {
        data: valuesToPush,
      });
    }

    setDisableTrackEvents(false);
  }, [filteredBoats, areBoatsLoading, routerReady]);
};
